// Centralized definition for validation steps used in Product header and Validation form
export const VALIDATION_STEPS = [
    {
        key: 0,
        id: 'grammar_style',
        label: 'Grammar & style',
        instruction:
            'Check grammar, spelling, clarity, tone, and formatting consistency. Ensure the writing style matches our standards.',
    },
    {
        key: 1,
        id: 'logic_big_picture',
        label: 'Logic & bigger picture',
        instruction:
            'Verify logical flow, argument consistency, supporting evidence, and overall coherence of the narrative.',
    },
    {
        key: 2,
        id: 'strategic_level',
        label: 'Strategic level',
        instruction:
            'Evaluate strategic insights, implications, and alignment with objectives. Identify risks and opportunities.',
    },
];

export const PITCH_VALIDATION_STEPS = [
    ...VALIDATION_STEPS,
    {
        key: 3,
        id: 'create_icr',
        label: 'Create ICR',
        instruction:
            'Generate an ICR draft from the pitch and report metadata, review/edit the prefilled fields, then create and link the ICR.',
    },
];

